import React from "react";
import { uniqBy } from "lodash";
import PropTypes from "prop-types";
import Timeline from "./Timeline";
import RegionTrack from "./RegionTrack";
import TrackGroup from "./TrackGroup";
import Panel from "../../../common/Panel/Panel";
import colorPalette from "../../../common/colorPalette";
import connectToMedia from "../../Media/connectToMedia";
import ProgressControls from "../Controls/ProgressControls";

const mapStateToProps = (state) => ({ ...state.media });

class Index extends React.PureComponent {
  static propTypes = {
    isSentimentAnalyzerOn: PropTypes.bool,
  };
  constructor(props) {
    super(props);
    this.state = {
      isTimeLineVisible: false,
    };
  }
  setTimelineVisibility(ranges) {
    let that = this;
    that.setState({
      isTimeLineVisible: !that.state.isTimeLineVisible,
    });
  }

  componentDidUpdate() {
    const { updatePlayerTopSectionHeight } = this.props;
    updatePlayerTopSectionHeight();
  }

  render() {
    const {
      turns,
      detectors,
      isSentimentAnalyzerOn,
      mediaId,
      isChatTextMedia,
      metaData,
      transcriptLength,
    } = this.props;

    return (
      <Panel>
        <div style={{ overflow: "hidden" }}>
          <ProgressControls
            isChatTextMedia={isChatTextMedia}
            mediaId={mediaId}
            isTimeLineVisible={this.state.isTimeLineVisible}
            setTimelineVisibility={() => this.setTimelineVisibility()}
            messagesDuration={turns?.reduce(function (p, v) {
              return p.end > v.end ? p.end : v.end;
            }, -1)}
          />
        </div>
        {this.state.isTimeLineVisible && (
          <Timeline
            isSentimentAnalyzerOn={isSentimentAnalyzerOn}
            isChatTextMedia={isChatTextMedia}
            messagesDuration={turns?.reduce(function (p, v) {
              return p.end > v.end ? p.end : v.end;
            }, -1)}
          >
            <TrackGroup>
              {uniqBy(turns, "speaker").map(({ speaker }, i) => (
                <RegionTrack
                  messagesDuration={turns?.reduce(function (p, v) {
                    return p.end > v.end ? p.end : v.end;
                  }, -1)}
                  turns={turns}
                  isChatTextMedia={isChatTextMedia}
                  transcriptLength={transcriptLength}
                  key={speaker}
                  icon="user"
                  title={speaker}
                  regions={turns.filter((turn) => turn.speaker === speaker)}
                  color={!i % 2 ? "#9aca62" : "#0079c0"}
                  height={10}
                  isSentimentAnalyzerOn={isSentimentAnalyzerOn}
                />
              ))}
              {detectors.map((detector, i) => (
                <RegionTrack
                  isDetectorTrack
                  messagesDuration={detectors
                    ?.map((val) => val.intervals)
                    ?.flat()
                    ?.reduce(function (p, v) {
                      return p.end > v.end ? p.end : v.end;
                    }, -1)}
                  turns={turns}
                  isChatTextMedia={isChatTextMedia}
                  transcriptLength={transcriptLength}
                  key={detector.detector}
                  icon="alert"
                  title={detector.name}
                  regions={detector.intervals}
                  color={colorPalette.gray.darken(0.5).hex()}
                  height={10}
                />
              ))}
            </TrackGroup>
          </Timeline>
        )}
      </Panel>
    );
  }
}

export default connectToMedia(mapStateToProps)(Index);
